<template>
  <page-stepped
    ref="page"
    :title="$t('Imports_Title_CreateImport')"
    :steps="steps"
    :model="model"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :rules="rules"
    :save-button="$t('Imports_Button_RunImport')"
    :breadcrumbs="breadcrumbs"
    :after-save="afterSave"
  />
</template>

<script>
import PageStepped from '@/common/components/page/PageStepped'
import StepImportDataSource from '@/modules/imports/components/StepImportDataSource'
import StepImportDataMapping from '@/modules/imports/components/StepImportDataMapping'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { validationMixin } from '@/modules/imports/mixins/ValidationMixin'
import { attributesMixin } from '@/modules/imports/mixins/AttributesMixin'

export default {
  name: 'ImportFormPage',

  mixins: [validationMixin, attributesMixin],

  components: {
    PageStepped
  },

  props: {
    type: String
  },

  data() {
    return {
      model: {
        name: '',
        type: this.type || 'profiles',
        source: {
          type: ''
        },
        config: {
          columns: [],
          event: null
        },
        schedule: {
          frequency: 'daily',
          time: '00:00'
        },
        active: 1
      },
      steps: [
        {
          name: 'data_source',
          title: this.$t('Imports_Tab_DataSource'),
          component: StepImportDataSource,
          completed: false,
          rules: {
            name: {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            config: {
              event: [
                {
                  validator: this.validateEventField
                }
              ],
              columns: [
                {
                  type: 'array',
                  required: true,
                  message: this.$t('RestForm_SchemaIsRequired'),
                  min: 1
                },
                {
                  validator: this.validateUserIdCol
                },
                {
                  validator: this.validateColumns
                }
              ]
            },
            source: {
              type: {
                required: true,
                message: this.$t('RestForm_FieldIsRequired')
              },
              integration_id: {
                required: true,
                message: this.$t('RestForm_FieldIsRequired')
              },
              file_name: {
                required: true,
                message: this.$t('RestForm_FieldIsRequired')
              }
            }
          },
          props: {}
        },
        {
          name: 'data_mapping',
          title: this.$t('Imports_Tab_DataMapping'),
          component: StepImportDataMapping,
          completed: false,
          rules: {},
          props: {
            attributes: [],
            filterableAttributes: [],
            integrations: {}
          }
        }
      ]
    }
  },
  mounted() {
    this.setFilterableAttributes()
  },
  computed: {
    fetchEndpoint() {
      return [this.fsIntegrationsEndpoint, this.attributesEndpoint]
    },

    fsIntegrationsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations`,
        params: {
          type: 'sftp,gcs,s3',
          active: 1
        },
        handler: data => {
          this.$set(this.steps[0].props, 'integrations', data)
        }
      })
    },

    attributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tags`,
        params: {
          sort: 'title',
          attribute_profile: 1
        },
        handler: data => {
          this.steps[1].props.attributes = data
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'POST',
        url: `imports/import`
      })
    },

    rules() {
      return this.steps.reduce(
        (obj, item) => Object.assign(obj, item.rules),
        {}
      )
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Imports_Breadcrumb_Imports')
        },
        {
          label: this.$t('Imports_Breadcrumb_CreateImport')
        }
      ]
    },

    currentStepName() {
      return this.$refs.page.currentStep.name
    }
  },

  methods: {
    afterSave(data) {
      this.$router.push(
        projectRoute({
          name: 'TaskHistoryView',
          query: { id: data.task_id }
        })
      )
    }
  },
  watch: {
    'model.type': {
      handler() {
        this.setFilterableAttributes()
        this.model.config.columns = []
      }
    },
    'model.config.event': {
      handler() {
        this.setFilterableAttributes()
        this.model.config.columns = []
      }
    }
  }
}
</script>

<style scoped>
>>> .Profile_Attribute_Input_Error {
  border-color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/modules/imports/pages/ImportFormPage.vue